module.exports = __webpack_public_path__ + "img/KNC.64a949bc.svg";